// Video Popup 
const careExternalPlayVideos = document.querySelectorAll('.external-video__container--care');
const careVideoPopup = document.querySelector('.external-video__video-popup--care');

// Open Popup
careExternalPlayVideos.forEach(el => el.addEventListener('click', function(e) {
  console.log(e);
  const targetSection = e.target.closest(".external-video__container").dataset.section;
  const targetvideoLink = document.querySelector('.external-video__url[data-section="' + targetSection + '"]').innerText;

  const videoHTML = `
  <div class="external-video__video-container">
    <div class="external-video__video">
      <iframe 
        src="${targetvideoLink}" 
        title="YouTube video player" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen>
      </iframe>
    </div>
  </div>`;

  careVideoPopup.innerHTML = '';
  careVideoPopup.classList.remove('hidden');
  careVideoPopup.classList.add('videoIsAdded');
  careVideoPopup.insertAdjacentHTML('beforeend', videoHTML);
}))

// Close popup
const closecareVideoPopup = function() {
  careVideoPopup.classList.add('hidden');
  careVideoPopup.innerHTML = '';
}

careVideoPopup.addEventListener('click', closecareVideoPopup);


window.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closecareVideoPopup();
});